<template>
	<!-- <product-attr-detail :is-edit='false'></product-attr-detail> -->
	<attr-detail :is-edit='false'>
	</attr-detail>
</template>

<script>
	import AttrDetail from './attrDetail.vue'
	export default {
		name: 'addProductAttr',
		components: {
			AttrDetail
		}
	}
</script>

<style scoped>

</style>
